import * as React from 'react'

import { cancelSpeech, isSpeakingUtterance, isTextToSpeechSupported, speak as speakUtterance } from '../../libs/speech/speechManager'

interface UseTextToSpeechOptions {
  onBoundary?: (charIndex: number) => void;
  onEnd?: () => void;
}

const useTextToSpeech = ({ onBoundary, onEnd, }: UseTextToSpeechOptions = {}) => {
  const [isSpeaking, setIsSpeaking] = React.useState(false)
  const utteranceRef = React.useRef<object | null>(null)

  const finishSpeaking = () => {
    utteranceRef.current = null
    setIsSpeaking(false)
    if (onEnd) { onEnd() }
  }

  const cancelOwnSpeech = () => {
    if (isSpeakingUtterance(utteranceRef.current)) { cancelSpeech() }
  }

  React.useEffect(() => cancelOwnSpeech, [])

  const speak = (text: string) => {
    utteranceRef.current = speakUtterance(text, {
      onBoundary,
      onEnd: finishSpeaking,
      onInterrupted: finishSpeaking,
      onStart: () => setIsSpeaking(true),
    })
  }

  return {
    cancel: cancelOwnSpeech,
    isSpeaking,
    isSupported: isTextToSpeechSupported(),
    speak,
  }
}

export default useTextToSpeech
